import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Infographic } from './infographic.model';
import infographicService from './infographic.service';

// namespace
export const INFOGRAPHIC_STORE_NAMESPACE = 'infoGraphicStore';

// state
interface InfographicState {
  infoGraphics: Infographic[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: InfographicState = {
  infoGraphics: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<InfographicState> = {
  [mutationConstant.FETCH]: (state: InfographicState, infoGraphics: Infographic[]) => {
    state.infoGraphics = infoGraphics;
  },
  [mutationConstant.PENDING]: (state: InfographicState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: InfographicState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: InfographicState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<InfographicState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<InfographicState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      infographicService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<InfographicState, RootState> = {
  [getterConstant.ALL]: (state: InfographicState) => state.infoGraphics,
  [getterConstant.BY_ID]: (state: InfographicState) => (id: number) => state.infoGraphics.find(m => m.id === id),
  [getterConstant.STATUS]: (state: InfographicState) => state.status,
};

// module
const module: Module<InfographicState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const InfographicGetter = {
  ALL: `${INFOGRAPHIC_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${INFOGRAPHIC_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${INFOGRAPHIC_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const InfographicAction = {
  FETCH: `${INFOGRAPHIC_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
